import { useMutation } from '@src/query';


/**
 * Settings → Notifications mutation hook (T10). Wraps the shared `useMutation`
 * engine with the injected-`queryClient` `mutateFn({ apiClient, queryClient })`
 * contract — the corelib query singleton is NOT imported here. Invalidation runs
 * inside `mutateFn`; the caller passes the prefs `queryKey` it already holds from
 * `useNotificationPrefsQuery`, so the exact cache key is preserved unchanged.
 *
 * Mirrors `query/garage/useDonorMutations.js`. The page toggles optimistically
 * and reverts on error; this hook just performs the full-list PUT upsert.
 */

/** Upsert the full per-event preference list. Variables: `{ sellerId, list,
 * queryKey }`. */
function useNotificationPrefsMutation(params) {
  return useMutation({
    mutateFn: ({ apiClient, queryClient, sellerId, list, queryKey }) => apiClient
      .request({
        method: 'PUT',
        payload: { preferences: list },
        queryParams: { seller: sellerId },
        url: '/notifications/preferences/',
      })
      .then((data) => queryClient.invalidateQueries({ queryKey }).then(() => data)),
    ...params,
  });
}


export { useNotificationPrefsMutation };
